import { render, staticRenderFns } from "./common-back.vue?vue&type=template&id=bb15494c&scoped=true&"
import script from "./common-back.vue?vue&type=script&lang=js&"
export * from "./common-back.vue?vue&type=script&lang=js&"
import style0 from "./common-back.vue?vue&type=style&index=0&id=bb15494c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb15494c",
  null
  
)

export default component.exports